import React from 'react'
import './faqs.scss'

import FAQ_DATA from './faqdata.json'
import VO_QUESTION_MARK from '../../../../assets/VO_QUESTION_MARK.svg'

const FAQs = () => {
    return (
        <div className="faqs">
            <div className="faqs__wrapper">
                <h2 className="primary__heading">Frequently Asked Questions</h2>
                <p>
                    Keep your business running with professional, 24/7 business phone
                    answering. 85% Of People Whose Calls Aren’t Answered Will Not Call
                    Back. Never Miss An Enquiry. Win More Business Opportunities with our
                    award-winning Live Telephone Answering Services.
                </p>

                <div className="faqs__wrapper__items">
                    {FAQ_DATA.map(({question, answer}, index) => (
                        <FAQsItem key={index} question={question} answer={answer}/>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default FAQs

const FAQsItem = ({question, answer}) => {
    return (
        <div className="faqs_item">
            <div>
                <img src={VO_QUESTION_MARK} alt=""/>
                <h2 className="secondary__heading">{question}</h2>
            </div>
            <div>
                <p>{answer}</p>
            </div>
        </div>
    )
}
